export default __webpack_public_path__ + "static/media/Application_form2.217bff09.odt";